/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RedeemXpMultiplierBody
 */
export interface RedeemXpMultiplierBody {
    /**
     * 
     * @type {string}
     * @memberof RedeemXpMultiplierBody
     */
    transactionHash?: string;
    /**
     * 
     * @type {string}
     * @memberof RedeemXpMultiplierBody
     */
    nftOwnershipId: string;
}

export function RedeemXpMultiplierBodyFromJSON(json: any): RedeemXpMultiplierBody {
    return RedeemXpMultiplierBodyFromJSONTyped(json, false);
}

export function RedeemXpMultiplierBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): RedeemXpMultiplierBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'transactionHash': !exists(json, 'transactionHash') ? undefined : json['transactionHash'],
        'nftOwnershipId': json['nftOwnershipId'],
    };
}

export function RedeemXpMultiplierBodyToJSON(value?: RedeemXpMultiplierBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'transactionHash': value.transactionHash,
        'nftOwnershipId': value.nftOwnershipId,
    };
}


